import React from 'react';
import { AwardIcon, BadgeCheckIcon, FileTextIcon, MapPinIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
import { trustSignals } from '../data/trustSignals';
import { ui } from '../data/translations';
const signalIcons = [ShieldCheckIcon, AwardIcon, UsersIcon, FileTextIcon, BadgeCheckIcon, MapPinIcon];
export function WhyChooseUs() {
  const {
    t
  } = useLanguage();
  return <section id="why-us" className="w-full bg-white pb-20 lg:pb-28" data-id="element-240" data-mp="g6bdtm5ktswm">
      <div className="mx-auto max-w-7xl border-t border-black/10 px-5 pt-20 lg:px-8 lg:pt-28" data-id="element-241" data-mp="l7qz9fbo21fj">
        <div className="max-w-2xl" data-id="element-242" data-mp="77pw1t7xihww">
          <h2 className="font-display text-3xl font-bold leading-tight text-navy lg:text-4xl" data-id="element-243" data-mp="78ra86k8rkiu">{t(ui.whyUs.title)}</h2>
          <p className="mt-4 text-steel" data-id="element-244" data-mp="bactqara6x20">{t(ui.whyUs.subtitle)}</p>
        </div>

        <ul className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-245" data-mp="21lr0ctm8zx4d">
          {trustSignals.map((signal, i) => {
          const Icon = signalIcons[i];
          return <li key={signal.title.en} className="rounded-lg border border-black/10 border-l-4 border-l-gold bg-white p-8" data-id="element-246" data-mp="1nd2erejsaqoo" data-mpi={i}>
                <Icon className="h-12 w-12 text-navy" strokeWidth={1.5} aria-hidden="true" data-id="element-247" data-mp="1idpu90gdxvp9" />
                <h3 className="mt-5 font-display text-lg font-semibold text-navy" data-id="element-248" data-mp="1x6j86hg0e3rt">{t(signal.title)}</h3>
                <p className="mt-2 text-steel" data-id="element-249" data-mp="1s7gcvoptzbx1">{t(signal.description)}</p>
              </li>;
        })}
        </ul>

        <div className="mt-12" data-id="element-250" data-mp="zh7txunh0nhe">
          <a href="#contact" className="inline-flex h-12 items-center justify-center rounded-md border-2 border-navy px-6 font-display text-sm font-semibold text-navy transition-colors duration-150 hover:bg-navy hover:text-white" data-id="element-251" data-mp="zhzp54d5oj75">
            {t(ui.cta.contactUs)}
          </a>
        </div>
      </div>
    </section>;
}